import { atom, selector } from "recoil";
import { buffer, simplify } from "@turf/turf";

export const bufferRadiusAtom = atom({
  key: "bufferRadiusAtom",
  default: 0.8,
});

export const selectedFocusAreaAtom = atom({
  key: "selected-focus-area-atom",
  default: null,
});

export const selectedRegionUrlQuerySelector = selector({
  key: "selectedRegionUrlQuerySelector",
  get: ({ get }) => {
    const selectedRegion = get(selectedRegionSelector);
    if (selectedRegion) {
      return `geometry=${encodeURIComponent(
        JSON.stringify({
          rings: selectedRegion.geometry.coordinates,
          spatialReference: { wkid: 4326 },
        })
      )}&geometryType=esriGeometryPolygon`;
    }
    return "";
  },
});

export const selectedRegionSelector = selector({
  key: "selected-region-selector",
  get: ({ get }) => {
    const selectedFocusArea = get(selectedFocusAreaAtom);
    const bufferRadius = get(bufferRadiusAtom);

    if (!selectedFocusArea) {
      return null
    }
    
    if (typeof bufferRadius !== "number") {
      return null;
    }

    if (bufferRadius === 0) {
      return selectedFocusArea;
    }

    const bufferedSelectedFocusArea = buffer(
      selectedFocusArea.geometry,
      bufferRadius,
      {
        steps: 1,
      }
    );

    const options = { tolerance: 0.0002, highQuality: true };
    const simplifiedBufferedSelectedFocusArea = simplify(
      bufferedSelectedFocusArea,
      options
    );
    return simplifiedBufferedSelectedFocusArea;
  },
});

export const selectedRegionESRIGeometrySelector = selector({
  key: "selectedRegionGeometrySelector",
  get: ({ get }) => {
    const selectedRegion = get(selectedRegionSelector);

    if (selectedRegion) {
      return {
        rings: selectedRegion.geometry.coordinates,
        spatialReference: { wkid: 4326 },
      }
    }

    return null
  }
})

export const selectedRegionQueryParamsSelector = selector({
  key: "selectedRegionQueryParamsSelector",
  get: ({ get }) => {
    const selectedRegionGeometry = get(selectedRegionESRIGeometrySelector);

    if (selectedRegionGeometry) {
      return {
        geometry: selectedRegionGeometry,
        geometryType: "esriGeometryPolygon",
        where: "1=1",
        f: "geojson",
      };
    }
    
    return "";
  },
});